import { SendGiftCreateCollectionTemplate } from '@hero/components';

export default function SendGiftCreateCollectionPage() {
  return <SendGiftCreateCollectionTemplate />;
}
